var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts"},[_c('div',{ref:"barMian",staticClass:"chart-cont"})])
}
var staticRenderFns = []

export { render, staticRenderFns }